import {
  convertPRToPO,
  createPurchaseRequisition,
  getPurchaseRequisitionAudit,
  getPurchaseRequisitionAuditDetails,
  getPurchaseRequisitionDetails,
  getPurchaseRequisitionList,
  getPurchaseRequisitionSequence,
  updatePurchaseRequisition,
  updatePurchaseRequisitionStatus,
  addToFavourite,
  removeFromFavourite,
  getPrFavoritesList
} from '../api';


export const getPurchaseRequisitionListReq = async (body) => {
  const response = await getPurchaseRequisitionList(body);
  return response.payload;
};

export const getPurchaseRequisitionDetailsReq = async (id) => {
  const response = await getPurchaseRequisitionDetails(id);
  return response.payload;
};

export const getPurchaseRequisitionAuditReq = async (id) => {
  const response = await getPurchaseRequisitionAudit(id);
  return response.payload;
};

export const getPurchaseRequisitionAuditDetailsReq = async (id, auditId) => {
  const response = await getPurchaseRequisitionAuditDetails(id, auditId);
  return response.payload;
};

export const getPurchaseRequisitionSequenceReq = async () => {
  const response = await getPurchaseRequisitionSequence();
  return response.payload;
};

export const createPurchaseRequisitionReq = async (body) => {
  const response = await createPurchaseRequisition(body);
  return response;
};

export const updatePurchaseRequisitionReq = async (body) => {
  const response = await updatePurchaseRequisition(body);
  return response;
};

export const updatePurchaseRequisitionStatusReq = async (body) => {
  const response = await updatePurchaseRequisitionStatus(body);
  return response;
};

export const convertToPurchaseOrderReq = async (body) => {
  const response = await convertPRToPO(body);
  return response;
}

export const getPrFavoritesListReq = async () => {
  const response = await getPrFavoritesList();
  return response.payload;
};

export const addToFavouriteReq = async (id) => {
  const response = await addToFavourite(id);
  return response;
};

export const removeFromFavouriteReq = async (id) => {
  const response = await removeFromFavourite(id);
  return response;
};